import { ProductDataError } from '@/lib/api/product-data-client'
import { SUPPORT_EMAIL } from '@/utils/constants'
import { formatUsd } from '@/utils/formatters'

/** `$149` from cents. */
export function formatPrice(cents: number): string {
  return formatUsd(cents / 100)
}

/** Said when the owner asks how the IRS fee waiver works: the one sentence both the intro and the form repeat. */
export const WAIVER_LINE = `Free if the mistake came from documents we prepared for you: write to ${SUPPORT_EMAIL} before paying and we will waive it.`

/** Shown up front, in place of the start and pay actions, when the API says online payment is not open. */
export const CHECKOUT_UNAVAILABLE_LINE = `Online payment for this service is not open yet. Write to ${SUPPORT_EMAIL} and we will help.`

/**
 * What a failed request tells the customer. An answer from the API Worker, 4xx or 5xx, carries a
 * message written for the customer that already says how to recover (a 503 `price_unavailable`
 * says to write to support), so it is shown as it is. A request that never got an answer
 * (`status` 0), or one whose answer had no message of its own (`HTTP 502`), gets the generic
 * recovery line, never a developer string.
 */
export function failureMessage(error: unknown): string {
  if (error instanceof ProductDataError && error.status >= 400 && error.message && !/^HTTP \d+$/.test(error.message)) {
    return error.message
  }
  return `That did not go through, and nothing was lost. Check your connection and try again. If it keeps failing, write to ${SUPPORT_EMAIL}.`
}
